export function uniqueValues(items) {
  let seen = {};
  let out = [];
  let len = items.length;
  let j = 0;
  for (let i = 0; i < len; i++) {
    let item = items[i];
    if (seen[item] !== 1) {
      seen[item] = 1;
      out[j++] = item;
    }
  }
  return out;
}

export function splitByRanges(items, ranges) {
  const result = [];
  for (let i = 0; i < ranges.length; i++) {
    const people = items.filter(d => {
      return i === ranges.length - 1 ? d > ranges[i] : i === 0 ? d >= ranges[i] && d <= ranges[i + 1] : d > ranges[i] && d <= ranges[i + 1];
    });
    result.push(people);
  }
  return result;
}

export function average(items) {
  const sum = items
    .filter(e => !isNaN(e))
    .reduce((acc, cur) => {
      return acc + cur;
    }, 0);
  return items.length > 0 ? Math.round(sum / items.length) : 0;
}
